import * as React from 'react'

import {
  ConversationStreamStatuses,
  useConversationStream,
  type UseConversationStreamResult,
} from '../hooks/useConversationStream'

export type ConversationContextValue = UseConversationStreamResult

const DEFAULT_CONTEXT: ConversationContextValue = {
  items: [],
  status: ConversationStreamStatuses.IDLE,
  thinkingLabel: null,
  telemetry: [],
  sendMessage: () => false,
  sendSilentMessage: () => false,
}

export const ConversationContext =
  React.createContext<ConversationContextValue>(DEFAULT_CONTEXT)

export const ConversationProvider = ({
  initialQuery,
  children,
}: React.PropsWithChildren<{ initialQuery: string }>) => {
  const conversation = useConversationStream(initialQuery)

  return (
    <ConversationContext.Provider value={conversation}>
      {children}
    </ConversationContext.Provider>
  )
}

export const useConversation = (): ConversationContextValue =>
  React.useContext(ConversationContext)
